import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

const getListRekapPesertaIjazah = async (tahun: String) => {
  const response = await api.get("/setting/verifikator-ijazah/index", {
    withCredentials: true,
    params: { tahun },
  });
  return response.data;
};

export default function SettingVerifikatorRaportPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRekapPesertaIjazah", selectedTahun?.label],
    queryFn: () => getListRekapPesertaIjazah(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
